/*
 * Collection filter dropdowns.
 *
 * The open/close behaviour is the browser's own <details> element, so the
 * filters still work with JavaScript off: every option is a plain link to a
 * tag route. This file adds only the three things <details> cannot do on its
 * own - typing to narrow a long list, closing a panel when another one opens
 * or when you click away, and returning focus sensibly on Escape.
 */
(function () {
  var drops = Array.prototype.slice.call(document.querySelectorAll('[data-es-drop]'));
  if (!drops.length) return;

  function closeAll(except) {
    drops.forEach(function (d) {
      if (d !== except) d.open = false;
    });
  }

  drops.forEach(function (drop) {
    var input = drop.querySelector('[data-es-search]');
    var list = drop.querySelector('[data-es-list]');
    var empty = drop.querySelector('[data-es-empty]');
    var options = list ? Array.prototype.slice.call(list.querySelectorAll('li')) : [];

    drop.addEventListener('toggle', function () {
      if (!drop.open) return;
      closeAll(drop);
      if (input) {
        input.value = '';
        filter('');
        // Only steal focus for a pointer user on a roomy screen; on a phone
        // the keyboard would cover the list the moment it opens.
        if (window.matchMedia('(min-width: 750px)').matches) input.focus();
      }
    });

    function filter(term) {
      var q = term.trim().toLowerCase();
      var hits = 0;
      options.forEach(function (li) {
        var text = (li.textContent || '').trim().toLowerCase();
        var match = q === '' || text.indexOf(q) !== -1;
        li.hidden = !match;
        if (match) hits++;
      });
      if (empty) empty.hidden = hits !== 0;
    }

    if (input) {
      input.addEventListener('input', function () { filter(input.value); });
      input.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        // Enter follows the first visible option, so a search can be finished
        // from the keyboard without reaching for the mouse.
        var first = options.filter(function (li) { return !li.hidden; })[0];
        var link = first && first.querySelector('a');
        if (link) {
          event.preventDefault();
          link.click();
        }
      });
    }
  });

  document.addEventListener('click', function (event) {
    var inside = drops.some(function (d) { return d.contains(event.target); });
    if (!inside) closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = drops.filter(function (d) { return d.open; })[0];
    if (!open) return;
    open.open = false;
    var summary = open.querySelector('summary');
    if (summary) summary.focus();
  });
})();
